  import ReactDOM from 'react-dom/client';
  import './index.css';
  import { LogBox, SafeAreaView, Text } from 'react-native';
  import { AppRegistry } from 'react-native';
  import { createBrowserHistory } from 'history';
  import { store as newStore , persistor } from './src/store/newstore';
  import { Provider } from 'react-redux';
  import { PersistGate } from 'redux-persist/integration/react';
  import { SafeAreaProvider } from 'react-native-safe-area-context';
  import * as Sentry from "@sentry/react";
  import { isProduction } from '@app/api/apis';
  import MobileFeedbackForm from './FeedbackComp';
  import AppWebNew from './AppWebNew';

  if (typeof (globalThis as any).__DEV__ === 'undefined') {
    (globalThis as any).__DEV__ = process.env.NODE_ENV !== 'production';
  }

  LogBox.ignoreAllLogs(true); // 👈 Suppresses all warning/error logs

  isProduction && Sentry.init({
    dsn: "https://99341d07eb449a52f703e3547ff74750@o4504883868008448.ingest.us.sentry.io/4509394465128448",
        replaysOnErrorSampleRate: 0.1, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.

    beforeSend(event, hint) {
      // Check if it is an exception, and if so, show the report dialog
      if (event.exception && event.event_id) {
      }
      return event;
    },

    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.browserProfilingIntegration(),
    
      Sentry.replayIntegration({
        networkDetailAllowUrls: [/https:\/\/api\.voltmoney\.in/],
        networkRequestHeaders: ['X-Custom-Header'],
        networkResponseHeaders: ['X-Custom-Header'],
      }),
      
      
      // Sentry.feedbackIntegration({
      //   colorScheme: "system",
      //   isEmailRequired: true,

      // }),


    ],
    replaysSessionSampleRate: 0,
    // Tracing
    tracesSampleRate: 1.0, 
    tracePropagationTargets: ["https://app.voltmoney.in/", /^\/api\//]
    // // Set profilesSampleRate to 1.0 to profile every transaction.
    // // Since profilesSampleRate is relative to tracesSampleRate,
    // // the final profiling rate can be computed as tracesSampleRate * profilesSampleRate
    // // For example, a tracesSampleRate of 0.5 and profilesSampleRate of 0.5 would
    // // results in 25% of transactions being profiled (0.5*0.5=0.25)
    // profilesSampleRate: 1.0
  });
  const history = createBrowserHistory();
  // 1. Set up the browser history with the updated location
  // (minus the # sign)
  const path = location.href.includes('#!')
    ? (/#!(\/.*)$/.exec(location.hash) || [])[1]
    : location.pathname;
  if (path) {
    // history.replace(path);
    history.replace({
      pathname: path,
      search: location.search,
    });
  }

  const ReduXWrapper = () => {
    return (
      <SafeAreaProvider>
        <Provider store={newStore}>
          <PersistGate loading={null} persistor={persistor}>
            <Sentry.ErrorBoundary
              fallback={({ error, resetError }) => {
                const eventId = Sentry.captureException(error);

                Sentry.captureMessage(`Error Captured:`, {
                  level: "info",
                  tags: { source: "Error_boundary_capture" },
                  extra: {
                    error: error.message,
                    event_id: eventId,
                  },
                });
  
                return (
                  <MobileFeedbackForm
                    onSubmit={async (formData) => {
                      
                      console.log("Event id received is", formData);
  
                      Sentry.captureMessage(`User Feedback: ${formData.name}`, {
                        level: "info",
                        tags: { source: "custom_feedback_form" },
                        user: {
                          email: formData.email,
                          username: formData.name,
                        },
                        extra: {
                          feedback: formData.description,
                          event_id: eventId,
                        },
                      });
                      if (Sentry.getCurrentScope) {
                        Sentry.getCurrentScope()?.setContext('replay', {
                          replay_id: Sentry.replay?.getReplayId?.(),
                          event_id: eventId,
                        });
                      }
  
                      resetError();
                    }}
                    onBack={undefined}
                  />
                );
              }}
              showDialog={false}
              beforeCapture={(scope, error, componentStack) => {
                scope.setTag("react_boundary", "Root");
                scope.setExtra("componentStack", componentStack);
              }}
            >
              <AppWebNew />
            </Sentry.ErrorBoundary>
          </PersistGate>
        </Provider>
      </SafeAreaProvider>
    );
  };
  AppRegistry.registerComponent('Volt', () => isProduction ? Sentry.wrap(ReduXWrapper) : ReduXWrapper );

  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement,
  );
  root.render(<ReduXWrapper />);


